import { useArrayFieldRemoveButtonProps } from '@eigtech/ui-shared-forms/shadcn'
import { US_STATES_AS_OPTIONS } from '@eigtech/ui-shared-us-states'
import { Button } from '@eigtech/ui/components/button'
import { Stack } from '@eigtech/ui/components/stack'
import { TrashIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { ContactFormAddressTypesFieldSchema } from './ContactFormSchema/AddressFieldSchema'
import {
  ContactForm,
  ContactFormArrayField,
  ContactFormInputField,
  ContactFormSelectField,
  useContactFormArrayFieldRowContext,
} from './ContactFormSchema/ContactFormSchema'

export function AddressFieldArray() {
  return (
    <ContactFormArrayField
      RowContainer={RowContainer}
      defaultValue={{ addressType: '', state: '' } as ContactForm['addresses'][number]}
      name="addresses"
      renderRow={AddressField}
    />
  )
}

function RowContainer({ children }: { children: ReactNode; index: number }) {
  const { id } = useContactFormArrayFieldRowContext()

  const removeButtonProps = useArrayFieldRemoveButtonProps()

  return (
    <Stack className="mb-4 gap-4" id={id}>
      {children}

      <Button {...removeButtonProps} variant="destructive-outline">
        Remove Address
        <TrashIcon />
      </Button>
    </Stack>
  )
}

export function AddressField() {
  const { index } = useContactFormArrayFieldRowContext()

  return (
    <Stack>
      <ContactFormInputField label="Street Address" name={`addresses.${index}.streetAddress`} />
      <ContactFormInputField label="Street Address 2" name={`addresses.${index}.streetAddress2`} />

      <div className="grid grid-cols-2 gap-2">
        <ContactFormInputField label="City" name={`addresses.${index}.city`} />

        <div className="grid grid-cols-2 gap-2">
          <ContactFormSelectField
            label="State"
            name={`addresses.${index}.state`}
            options={US_STATES_AS_OPTIONS}
            placeholder="Select State"
          />
          <ContactFormInputField
            inputProps={{ max: 5 }}
            label="ZIP Code"
            name={`addresses.${index}.zip`}
          />
        </div>
      </div>

      <ContactFormSelectField
        label="Address Type"
        name={`addresses.${index}.addressType`}
        options={ContactFormAddressTypesFieldSchema.options.map((option) => ({
          value: option,
        }))}
        placeholder="Select Address Type"
      />
    </Stack>
  )
}
